module.exports = __webpack_public_path__ + "static/media/uu-iswap.348dfc41.png";